// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__vlgke","body":"body__OwU5R","list":"list__mt2ws"};